import validate from "/codebuild/output/src1972232079/src/compass-v2/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src1972232079/src/compass-v2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "views-count": () => import("/codebuild/output/src1972232079/src/compass-v2/packages/frontend/middleware/views-count.ts")
}